module.exports = __webpack_public_path__ + "img/web4.ce3a8607.png";